import React from 'react';
import cloudSyncedSVG from '../../Images/cloud-upload.svg';

export const AmsSyncedItem = ({ text, color }) => {
  return (
    <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
      <img
        alt="amsSynced"
        src={cloudSyncedSVG}
        style={{ width: '22px', height: '22px', flexShrink: 0 }}
      />
      <span style={{ color, whiteSpace: 'nowrap' }}>{text}</span>
    </div>
  );
};
